export const SOCKET_CONNECT = 'socket-io/CONNECT';
export const SOCKET_ERROR = 'socket-io/ERROR';
export const SOCKET_DISCONNECT = 'socket-io/DISCONNECT';
export const SOCKET_RECONNECT = 'socket-io/RECONNECT';
export const SOCKET_RECONNECT_ATTEMPT = 'socket-io/RECONNECT_ATTEMPT';
export const SOCKET_RECONNECTING = 'socket-io/RECONNECTING';
export const SOCKET_RECONNECT_ERROR = 'socket-io/RECONNECT_ERROR';
export const SOCKET_RECONNECT_FAILED = 'socket-io/RECONNECT_FAILED';

export function socketConnect() {
  return {
    type: SOCKET_CONNECT,
  };
}

export function socketError(error) {
  return {
    type: SOCKET_ERROR,
    payload: error,
  };
}

export function socketDisconnect() {
  return {
    type: SOCKET_DISCONNECT,
  };
}

export function socketReconnect(attempt) {
  return {
    type: SOCKET_RECONNECT,
    payload: attempt,
  };
}

export function socketReconnectAttempt() {
  return {
    type: SOCKET_RECONNECT_ATTEMPT,
  };
}

export function socketReconnecting(attempt) {
  return {
    type: SOCKET_RECONNECTING,
    payload: attempt,
  };
}

export function socketReconnectError(error) {
  return {
    type: SOCKET_RECONNECT_ERROR,
    payload: error,
  };
}

export function socketReconnectFailed() {
  return {
    type: SOCKET_RECONNECT_FAILED,
  };
}



// WEBPACK FOOTER //
// ./app/actions/socket-io.js